import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { BudgetRegisterService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-budget-register',
  templateUrl: './select-budget-register.component.html',
  styleUrls: ['./select-budget-register.component.css']
})
export class SelectBudgetRegisterComponent implements OnInit {
  @Input() budgetRegisterControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() votebookGuid;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  budgetRegisters: any[] = [];
  toppingsControl = new FormControl([]);
  filteredBudgetRegisters: any[] = [];
  newFilteredBudgetRegisters: any[] = [];

  @ViewChild("budgetRegisterInput") budgetRegisterInput: ElementRef<HTMLInputElement>;
  budgetRegisterTargets: string[] = [];

  constructor(
    private budgetRegisterService: BudgetRegisterService
  ) {}

  ngOnInit(): void {
    this.viewModelStore
    .select(this.ColumnViewSelectors.selectAdvanceSearch_BudgetRegister_Field)
    .subscribe((data) => {
      this.budgetRegisters = data;
    });

    let pagination = new Pagination();
    pagination.offset = 0;
    pagination.limit = 10000;
    pagination.conditionalCriteria = [
      {
        columnName: "votebook_guid",
        operator: "=",
        value: this.votebookGuid,
      },
    ];

    this.subs.sink = this.budgetRegisterService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .subscribe({
        next: (results) => {
          results.data.forEach((item) => {
            this.filteredBudgetRegisters.push(item.bl_fi_budget_register);
          });
          this.newFilteredBudgetRegisters = this.filteredBudgetRegisters;
          console.log("Budget Registers", this.newFilteredBudgetRegisters); // Output the results
        },
        complete: () => {
          console.log("All requests completed.");
        },
        error: (error) => {
          console.error("An error occurred:", error);
        },
      });
    this.budgetRegisterControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterBudgetRegister(data));
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our budgetRegister
    if (value) {
      this.budgetRegisters.push(value);
    }

    // Clear the input value
    event.input.value = "";

    this.budgetRegisterControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetRegisterField({
        budgetRegisters: this.budgetRegisters,
      })
    );
  }

  remove(budgetRegister: string): void {
    const index = this.budgetRegisters.indexOf(budgetRegister);

    if (index >= 0) {
      this.budgetRegisters.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetRegisterField({
        budgetRegisters: this.budgetRegisters,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.budgetRegisters.push(event.option.value);
    this.budgetRegisterInput.nativeElement.value = "";
    this.budgetRegisterControl.setValue(null);
  }

  filterBudgetRegister(filterValue: string) {
    filterValue = filterValue?.trim().toLowerCase(); // Remove whitespace and make it lowercase
    this.filteredBudgetRegisters = this.newFilteredBudgetRegisters.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }

  optionClicked(event: Event, budgetRegister: any) {
    event.stopPropagation();
    this.toggleSelection(budgetRegister);
  }

  toggleSelection(budgetRegister: any) {
    console.log(budgetRegister);
    budgetRegister.selected = !budgetRegister.selected;
    this.budgetRegisterInput.nativeElement.value = "";
    if (budgetRegister.selected) {
      this.budgetRegisters.push(budgetRegister);
    } else {
      const i = this.budgetRegisters.findIndex(
        (value) => value.guid === budgetRegister.guid
      );
      this.budgetRegisters.splice(i, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_BudgetRegisterField({
        budgetRegisters: this.budgetRegisters,
      })
    );
  }

  onReset() {
    this.budgetRegisters = [];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
